exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wide { width: 90%; max-width: 975px;\n}\n", ""]);

// exports
